var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import { DivTag } from '../../Utils/AtomicTag';
var MessageContainer = /** @class */ (function (_super) {
    __extends(MessageContainer, _super);
    function MessageContainer(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            contentNode: [],
        };
        return _this;
    }
    MessageContainer.prototype.remove = function (key) {
        this.setState(function (_a) {
            var contentNode = _a.contentNode;
            return { contentNode: contentNode.filter(function (res) { return res.key !== key; }) };
        });
    };
    MessageContainer.prototype.add = function (noticeProps) {
        var index = this.state.contentNode.findIndex(function (res) { return res.key === noticeProps.key; });
        if (index === -1) {
            this.setState(function (_a) {
                var contentNode = _a.contentNode;
                return { contentNode: __spread(contentNode, [noticeProps]) };
            });
        }
        else {
            this.setState(function (_a) {
                var contentNode = _a.contentNode;
                var copyNode = __spread(contentNode);
                return {
                    contentNode: copyNode.map(function (res) {
                        if (res.key === noticeProps.key) {
                            return noticeProps;
                        }
                        else {
                            return res;
                        }
                    }),
                };
            });
        }
    };
    MessageContainer.prototype.render = function () {
        var contentNode = this.state.contentNode;
        var _a = this.props, className = _a.className, top = _a.top;
        var container = ['fixed', 'box-border'];
        return (React.createElement(DivTag, { name: MessageContainer.NAME, atomics: container, className: className, style: { marginTop: top } }, contentNode.map(function (res, i) { return (React.createElement(React.Fragment, { key: res.key }, res.content)); })));
    };
    MessageContainer.NAME = 'notice-container';
    return MessageContainer;
}(PureComponent));
export default MessageContainer;
MessageContainer.newInstance = function (props, callback) {
    var MountNode;
    if (typeof props.getContainer === 'function') {
        MountNode = props.getContainer();
    }
    else {
        MountNode = document.createElement('div');
        document.body.appendChild(MountNode);
    }
    var called = false;
    function ref(MessageContainer) {
        if (called) {
            return;
        }
        called = true;
        callback({
            notice: function (noticeProps) {
                MessageContainer.add(noticeProps);
            },
            removeNotice: function (key) {
                MessageContainer.remove(key);
            },
            component: MessageContainer,
            destroy: function () {
                ReactDOM.unmountComponentAtNode(MountNode);
                if (MountNode.parentNode) {
                    MountNode.parentNode.removeChild(MountNode);
                }
            },
        });
    }
    ReactDOM.render(React.createElement(MessageContainer, __assign({}, props, { ref: ref })), MountNode);
};
